// ============================================================================
// OBT F2-B — Park özelliği anahtar → etiket (paket-yerel)
// ============================================================================
// KAYNAK: backend/modules/obt/scope.py :: PARK_FEATURE_REGISTRY anahtarları.
// F2-A `campaign/**` alanına DOKUNULMAZ; bu paket kendi etiket haritasını tutar.
// Backend'de olmayan anahtar İCAT EDİLMEZ; bilinmeyen anahtar olduğu gibi gösterilir.
// ============================================================================

export const OBT_PARK_FEATURE_LABELS = Object.freeze({
  basketball_court: 'Basketbol Sahası',
  football_field: 'Futbol Sahası',
  fountain: 'Havuz / Süs Havuzu',
  parking: 'Otopark',
  playground: 'Çocuk Oyun Grubu',
  running_track: 'Koşu / Yürüyüş Parkuru',
  sports_equipment: 'Spor Aletleri',
  tennis_court: 'Tenis Kortu',
  volleyball_court: 'Voleybol Sahası',
  wc: 'Tuvalet (WC)',
});

export function parkFeatureLabelSafe(key) {
  return OBT_PARK_FEATURE_LABELS[key] || String(key || '');
}
